import axios from 'axios';
import errorHandlerFactory from './errorHandler';
import moment from 'moment';
import * as appConstants from '../common/constants';
import contentDisposition from 'content-disposition';


const iaErrorHandler = errorHandlerFactory('An error occured when fetching IA Results.');

export const getAvailableFilterValues = location => axios.get(location)
    .then(r => r.data.map(i => ({ title: i, value: i })));

export const getIndependentAmount = date => axios.get(`/IndependentAmount/IndependentAmountResults/${moment(date).format(appConstants.dateFormat)}`)
    .then(r => r.data).catch(iaErrorHandler);

export const exportCalcReports = (ids) => {     
    let suffix = 'sZip?ids='
    let obj = ids
    let zip = true
    if (ids.length === 1){
        suffix = '?id='
        obj = ids[0]
        zip = false
    }
    
    return axios.get(`IndependentAmount/ExportCalcReport${suffix}${obj}`,{
        responseType: 'blob',
      }).then((response) => {
        const parsedContentDisposition = response.headers['content-disposition'] && contentDisposition.parse(response.headers['content-disposition']);
        return { data: response.data, filename: parsedContentDisposition.parameters.filename, zip: zip }
    })
    
}   

export const getDowngradeReportAvailability = date => axios.get(`/IndependentAmount/IsDowngradeAvailable/${moment(date).format(appConstants.dateFormat)}`)
.then(r => r.data).catch(iaErrorHandler);

export const getOtcIaReportAvailability = date => axios.get(`/IndependentAmount/IsOtcIaAvailable/${moment(date).format(appConstants.dateFormat)}`)
.then(r => r.data).catch(iaErrorHandler);

export const exportFile = (fileInfo) => {        
        
    return axios.post(
        '/IndependentAmount/ExportFile',{...fileInfo},
        {
            responseType: 'blob',
        }).then((response) => {
        const parsedContentDisposition = response.headers['content-disposition'] && contentDisposition.parse(response.headers['content-disposition']);
        return { data: response.data, filename: parsedContentDisposition.parameters.filename, zip: false }
    })
    
}    